import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppInitService } from 'src/app/digigov/services/app-init.service';

@Injectable({
  providedIn: 'root',
})
export class EmsServiceService {
  emsConfig: any = {};
  processConfig: any = {
    EMS_WORKFLOW_ENABLE: 0,
  };
  hasConfig = new BehaviorSubject(false);

  constructor(
    private http: HttpClient,
    private appInitService: AppInitService
  ) {
    //this.emsConfig = this.appInitService?.appConfig?.configurableFields?.ems;
    this.appInitService?.getConfigurableFields()?.subscribe(() => {
      Object?.keys(this.appInitService?.appConfig?.configurableFields)?.forEach(
        (ele) => {
          try {
            let temp = ele?.toString()?.trim()?.split('.');
            if (temp[0] === 'ems') {
              this.emsConfig = {
                ...this.emsConfig,
                ...{
                  [temp[1]]: this.appInitService?.appConfig?.configurableFields[
                    ele
                  ],
                },
              };
            } else if (ele === 'EMS_WORKFLOW_ENABLE') {
              this.processConfig.EMS_WORKFLOW_ENABLE = Number(
                this.appInitService?.appConfig?.configurableFields[ele]
              );
            }
          } catch (e) { }
        }
      );
      this.hasConfig.next(true);
    });
  }

  getEmpDetails(url): Observable<any> {
    return this.http.get(url);
  }

  checkUniqueUserName(event): Observable<any> {
    return this.http.post('/admin/unique-username', {
      userName: event,
    });
  }

  checkUniqueEmail(event, emsAllEmployee): Observable<any> {
    return this.http.post('/admin/unique-email-id', {
      emailID: event,
      empId: emsAllEmployee.id ? emsAllEmployee.id : null,
    });
  }

  checkUniqueMobile(event, emsAllEmployee): Observable<any> {
    return this.http.post('/admin/unique-mobile-no', {
      mobile_no: event,
      empId: emsAllEmployee.id ? emsAllEmployee.id : null,
    });
  }

  checkUniqueTelNo(event, emsAllEmployee): Observable<any> {
    return this.http.post('/admin/unique-phone-no', {
      phoneNumber: event,
      empId: emsAllEmployee.id ? emsAllEmployee.id : null,
    });
  }

  saveEmpDetails(jsonData): Observable<any> {
    return this.http.post('/admin/employee-details', jsonData);
  }

  updateEmpDetails(jsonData): Observable<any> {
    return this.http.put(`/admin/user-profiles`, jsonData);
  }
  resetPassword(uniqueId: string) {
    return this.http.put('/security/reset-password', {
      userName: uniqueId,
    });
  }
  unlockAccount(uniqueId) {
    return this.http.post(`/security/unlock-user`, {
      userName: uniqueId,
    });
  }
  getAccountUnlockDetails(userName) {
    const url = `/security/user-details/${userName}`;
    return this.http.get(url);
  }
  emsPostGetDynamicGrid(): Observable<any> {
    return this.http?.get(`/admin/ems-post-grid-details?orgId=&lgunitID=`);
  }
  getHistory(empId) {
    return this.http.post(`/admin/emp-audit-dtls`, { empId: empId });
  }
  getEmpAuditByEmpId(empId) {
    return this.http.post(`/admin/employee-audit-details`, empId);
  }
}
